import { useEffect, useMemo } from 'react';

export function useResizeObserver(
  callback: (entries: ResizeObserverEntry[]) => void,
  element: Element
) {
  const resizeObserver = useMemo(() => {
    return new ResizeObserver(entries => {
      callback(entries);
    });
  }, [callback]);
  useEffect(() => {
    resizeObserver.observe(element);
  }, [element]);

  useEffect(() => {
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
}
